<template>
    <div class="chart-header" :class="{ 'chart-header--inner-padding': innerPadding }">
        <span class="chart-title">{{ title }}</span>
        <slot name="trailing"></slot>
    </div>
</template>

<script>
export default {
    name: "ChartHeader",
    props: {
        title: { type: String, required: true },
        /** no-padding 컨테이너 안에 둘 때 true → 헤더에만 좌우/상단 여백 적용 */
        innerPadding: { type: Boolean, default: false },
    },
};
</script>

<style scoped>
.chart-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    /* padding-bottom: 10px; */
    position: relative;
}
/* 
.chart-header::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: #e2e8f0;
} */

.chart-header--inner-padding {
    margin: var(--chart-inner, 12px) var(--chart-inner, 12px) 7px var(--chart-inner, 12px);
}

.chart-title {
    font-size: 15px;
    font-weight: 700;
    color: black;
}

/* slot에 배지 넣을 때 사용 (예: MONTH/YEAR) */
:deep(.chart-period-badge) {
    font-size: 10px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 999px;
    letter-spacing: 0.04em;
}
</style>
